import { tw } from "@sveabank/cc-common";
import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
	className?: string;
};

const BackgroundBleed = ({ children, className }: Props) => (
	<div
		className={tw(
			`relative flex justify-center content-[''] before:absolute before:left-[-100vw] before:h-full before:w-screen before:bg-inherit after:absolute after:right-[-100vw] after:h-full after:w-screen after:bg-inherit`,
			className,
		)}
	>
		{children}
	</div>
);

export default BackgroundBleed;
